import React, { type JSX } from 'react';
import { events } from '../../util/Events';

interface ComponentProps {
  activeQuestions: number[];
  index: number;
  question: string;
  answer: string;
}

/**
 * Question list item
 *
 * if question is clicked trigger parent callback
 * this way we can create an array of active questions
 */
export const Question = (props: ComponentProps): JSX.Element => {
  let itemClass = 'faq-list__item';

  if (props.activeQuestions.includes(props.index)) {
    itemClass += ' faq-list__item--active';
  }

  return (
    <li className={itemClass}
      onClick={(): void => events.emit('toggleQuestion', props.index)}>
      <div className="faq-list__question">
        <strong>{props.question}</strong>
      </div>
      <div className="faq-list__answer"
        dangerouslySetInnerHTML={{ __html: props.answer }}/>
    </li>
  );

};
